/* istanbul ignore file */
import React from 'react';
import { ListBreadcrumbItem, Breadcrumbs, BreadcrumbsProps } from 'framework/ui/BreadCrumbs';
import { useProjectUrl } from 'domain/shared/project';

const ProjectBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getListUrl } = useProjectUrl();
  const projectsListLink = getListUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Project" link={projectsListLink} />
      {children}
    </Breadcrumbs>
  );
};

export default ProjectBreadcrumbs;
